import React from "react";

function Burger() {
  return (
    <div class="wrapper" id="menu">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>voici notre menu N'hésitez pas appelez le 09 50 85 13 53</span>
          Burgers : le Menu +1€{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img
            src="https://ws.mcdonalds.fr/media/bf/b3/95/bfb395a2d5f07fce709a1ad84ad3496e03484c35"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Cheese burger <span>4.5€</span>
            </h4>
            <p>Un steak et une tranche de cheddar</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/McDonald%27s_Double_Cheeseburger_%281%29.jpg/800px-McDonald%27s_Double_Cheeseburger_%281%29.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Double Cheese <span>5.5€</span>
            </h4>
            <p> Deux steak,deux tranche de cheddar</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://www.pe.com/wp-content/uploads/2020/05/RPE-L-FARMERBOYS-0513-01-1.jpg?w=463"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Big cheese<span>6.5€</span>
            </h4>
            <p>Steak, bacon halal,fromage</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://allopizza88.fr/wp-content/uploads/2019/03/country-burger-600x600.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Country burger<span>6.5€</span>
            </h4>
            <p>Steak ,galette de pomme de terre,fromage</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="http://mr-kebab.fr/87-large_default/chicken-burger.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Chicken burger <span>5.5€</span>
            </h4>
            <p>Poulet pané avec une tranche de cheddar</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://www.salomon-foodworld.com/media/pages/sortiment/sunny-veggie-burger/636c671a24-1585124271/sunny-veggie-burger-freisteller-sesam-bun-72dpi-e2-800x.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Veggie burger<span>4.5€</span>
            </h4>
            <p>Galette de pomme de terre , oeuf , fromage</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Burger;
